namespace Matrix.Data {
    export class ModelTargetPickerColumns {
        static columnsKey = 'Data.ModelTargetPicker';
    }
}
